import { CLEAR_MESSAGES } from '../redux-action-types';

export default () => ({
  type: CLEAR_MESSAGES
});



// WEBPACK FOOTER //
// ./src/app/action-creators/clear-messages.js